import { http } from "@/lib/api";

const KEY = "vale_ref";

export function stashRefFromLocation() {
  const p = new URLSearchParams(window.location.search);
  const ref = (p.get("ref") || "").trim().toLowerCase();
  if (ref) {
    try { localStorage.setItem(KEY, ref); } catch {}
    return ref;
  }
  try { return localStorage.getItem(KEY) || ""; } catch { return ""; }
}

export function getStashedRef() {
  try { return localStorage.getItem(KEY) || ""; } catch { return ""; }
}

export function clearStashedRef() {
  try { localStorage.removeItem(KEY); } catch {}
}

export async function redeemStashedRef() {
  const code = getStashedRef();
  if (!code) return null;
  try {
    const { data } = await http.post("/referrals/redeem", { code });
    clearStashedRef();
    return data;
  } catch {
    // Silent: already redeemed, expired window, unknown code — no need to nag.
    clearStashedRef();
    return null;
  }
}

export async function lookupRef(code) {
  try {
    const { data } = await http.get("/referrals/lookup", { params: { code } });
    return data.referrer_name;
  } catch {
    return null;
  }
}
